import React from 'react';

export const CloseIcon = () => (
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.66699 1.646L12.333 12.31M1.66699 12.31L12.333 1.646" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" strokeLinejoin="round"/>
</svg>
);